import { useModal } from '@shape-ds/components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFaceFrown } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import { AppContext } from 'appContext';
import { useFormContext } from 'react-hook-form';
import { useContext } from 'react';
import { CaseForm, caseStatus, CaseStatus } from 'queries/cases/types';
import { GenericModal, ModalWidthEnum } from 'ui/GenericModal/GenericModal';
import { FormTextField } from 'ui/FormComponents';
import Modal from 'ui/GenericModal/Modal';

export const useGetCaseSelectModal = (handleSave: () => void, status: CaseStatus) => {
  const { t } = useTranslation();
  const { state } = useContext(AppContext);
  const { closeModal } = useModal();
  const { control, getValues, setValue, trigger, resetField, clearErrors } =
    useFormContext<CaseForm>();

  const modalClearEvidences = (
    <GenericModal
      title={t('case:evidences.messages.mandatory.title')}
      description={t('case:evidences.messages.mandatory.message')}
      width={ModalWidthEnum.MEDIUM}
      leftBtn={{
        style: 'primary',
        text: t('case:evidences.buttons.ok'),
        onClick: closeModal,
      }}
    >
      <FontAwesomeIcon icon={faFaceFrown} />
    </GenericModal>
  );

  const modalCanceled = (
    <Modal
      title={t('case:messages.cancel.title')}
      description={
        <FormTextField
          control={control}
          name="cancel_reason"
          placeHolderText={t('case:messages.cancel.placeholder')}
          rows={4}
          isRequired
        />
      }
      footer={{
        primary: {
          text: t('case:messages.cancel.button.primary'),
          onClick: () => {
            trigger('cancel_reason');
            const reason = getValues('cancel_reason');
            if (reason) {
              const username = state.auth.user?.name || '';
              setValue('cancel_reason', `@${username} canceled this case: "${reason}"`);
              setValue('status', caseStatus.canceled);
              handleSave();
              closeModal();
            }
          },
        },
        secondary: {
          text: t('case:messages.cancel.button.secondary'),
          onClick: () => {
            resetField('cancel_reason');
            setValue('status', status);
            clearErrors();
            closeModal();
          },
        },
      }}
    />
  );

  return {
    modalClearEvidences,
    modalCanceled,
  };
};
